<template>
  <div class="wnds_about_us">
    <div class="wau_banner">
      <img src="../../../static/img/about_banner.838245b.png" alt="">
    </div>
    <div id="wau_contbox_padding" class="wau_contbox">
      <div id="wauc_title">
        <ul class="wauc_title tcf-flex tcf-justify-justify">
          <li class="changeOfLanguage">关于我们</li>
          <li class="wauc_btnlist tcf-flex tcf-justify-justify">
            <div class="wauc_btnlist_active changeOfLanguage" @click="toScrollFn(430)">公司简介<img src="../../../static/img/about_turn_icon01.png" alt=""></div>
            <div class="changeOfLanguage" @click="toScrollFn(1420)">大事件<img src="../../../static/img/about_turn_icon01.png" alt=""></div>
            <div class="changeOfLanguage" @click="toScrollFn(2620)">创始团队<img src="../../../static/img/about_turn_icon01.png" alt=""></div>
            <!-- <div class="changeOfLanguage" @click="toScrollFn(3550)">联合发起人<img src="../../../static/img/about_turn_icon01.png" alt=""></div> -->
            <div class="changeOfLanguage" @click="toScrollFn(4450)">媒体矩阵<img src="../../../static/img/about_turn_icon01.png" alt=""></div>
            <!-- <div class="changeOfLanguage" @click="toScrollFn(3600)"><img src="../../../static/img/about_turn_icon01.png" alt=""></div> -->
          </li>
        </ul>
        <hr>
      </div>
      <div class="wau_zongzhi tcf-flex tcf-justify-justify">
        <img class="wau_zongzhi_icon" src="../../../static/img/about_left_icon01.png" alt="">
        <img class="wau_zongzhi_iconlf" src="../../../static/img/about_right_icon01.png" alt="">
        <div class="wauz_logo">
          <img src="../../../static/img/about_pic_01.7760f7a.png" alt="">
        </div>
        <div class="wauz_text">
          <img src="../../../static/img/about_content_title_01.png" alt="">
          <p class="changeOfLanguage">「为你读诗」是一个以诗歌为起点和纽带的国际文化艺术交流平台和诗意生活品牌。它致力于推动文化——尤其是中国文化，进入大众日常生活场景。</p>
          <p class="changeOfLanguage">迄今为止，我们已与来自全球多个国家、广泛领域的1000多位嘉宾展开了不同形式的合作，他们分布在政治、文化艺术、教育、科学、影视娱乐、传媒、公益、商业等诸多领域，
            包括但不仅限于国家元首或其配偶、驻华大使、各国作家诗人、科学家、音乐家、画家、导演、影视演员、歌手、体育运动员、企业家、公务员等。</p>
          <p class="changeOfLanguage">
            我们期待通过具有创造力的方式，将文学、音乐、美术、哲学、美学、戏剧、心理学等文化内容，开发为多样态的产品与服务，包括线上传播产品、知识付费与教育产品、生活产品、线下场景产品；并为中外政府、国际机构、主流媒体、商业品牌以及来自多领域的合作伙伴提供文化服务。
          </p>
          <p class="changeOfLanguage">通过完善的自媒体系统与全面的媒体场景渠道，我们拥有1000多万垂直优质用户，覆盖并影响超过3000万大众人群，并希望为更为广泛的用户带去兼有“知识、审美和情感”的诗意生活。</p>
          <p class="changeOfLanguage">在这个飞速行进的时代，我们需要安静、思考和美。</p>
        </div>
      </div>
      <div class="wau_zongzhi_bg tcf-flex tcf-justify-justify">
        <div></div>
        <div>
          <ul class="wauzb_box tcf-flex tcf-justify-end">
            <li class="wauzb_lf">
              <img src="../../../static/img/about_zblf.png" alt="">
            </li>
            <li class="wauzb_ct">
              <img src="../../../static/img/about_zbct.png" alt="">
            </li>
            <li class="wauzb_rg">
              
              <p class="changeOfLanguage" style="margin-top: 18px;"> 1. 推动诗歌以及中国文化进入大众日常生活场景。 </p> 
              <p class="changeOfLanguage" style="    font-size: 14px;line-height: 14px;color: #838383;">2. 以诗歌和中国文化，在国际上进行连接和交流。</p>
              <p class="changeOfLanguage">3. 保护人的感觉力、审美力以及爱的能力。</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="wau_dsj" class="wau_dsj">
      <!-- <img src="../../../static/img/about_content_title_05.png" alt=""> -->
      <div class="title">
        <h2>大事件</h2>
        <div></div>
        <!-- <h3>MILESTONE</h3> -->
      </div>
      <div class="waud_content">
        <div class="waudc_slider tcf-flex tcf-justify-justify" >
          <div class="waudcs_num">
            <p>10月</p>
            <p>-2019-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage otherLang">「为你读诗」与《诗刊》社、《光明日报》文艺部、安徽卫视联合发起“《诗·中国》同题诗征集活动”</p>
            <p class="changeOfLanguage">2019年10月，安徽广播电视台联合《诗刊》社推出大型诗歌文化类栏目《诗·中国》（2019年10月12日安徽卫视全国首播），「为你读诗」成为该栏目指定创意媒体平台。与此同时，《诗刊》社、《光明日报》文艺部、安徽卫视与「为你读诗」联合发起“《诗·中国》同题诗征集活动”，向全国人民发起以诗颂国的互动邀请。</p>
            <!-- <img src="../../../static/img/whac_readdetail.png" alt=""> -->
          </div>
          <div>
            <img src="../../../static/img/events/19.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify" >
          <div class="waudcs_num">
            <p>9月</p>
            <p>-2019-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage otherLang">“中国之声”与「为你读诗」联袂推出“共和国功勋模范为你读诗”项目献礼新中国成立70周年 </p>
            <p class="changeOfLanguage">2019年9月，中央广电总台“中国之声 ”与「为你读诗」联袂推出“共和国功勋模范为你读诗”项目。“共和国勋章”获得者袁隆平，“人民科学家”国家荣誉称号获得者叶培建，“人民教育家”国家荣誉称号获得者高铭暄，“人民艺术家”国家荣誉称号获得者王蒙，“人民楷模”国家荣誉称号获得者王文教，“人民楷模”国家荣誉称号获得者王启民读诗献礼新中国成立70周年。</p>
            <!-- <img src="../../../static/img/whac_readdetail.png" alt=""> -->
          </div>
          <div>
            <img src="../../../static/img/events/20.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify" >
          <div class="waudcs_num">
            <p>6月</p>
            <p>-2019-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」 与百度百科推出「我的枕边书」 </p>
            <p class="changeOfLanguage">2019年6月14日，「为你读诗」与百度百科推出短视频系列节目「我的枕边书」，每期由一位行业代表人物朗读喜爱书籍的选段，并分享自己的内心体会。</p>
            <!-- <img src="../../../static/img/whac_readdetail.png" alt=""> -->
          </div>
          <div>
            <img src="../../../static/img/events/22.jpeg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify" >
          <div class="waudcs_num">
            <p>5月</p>
            <p>-2019-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">文艺学堂推出《漫卷诗书》系列产品 </p>
            <p class="changeOfLanguage">2019年5月9日，「为你读诗」文艺学堂再次推出新的年度节目《漫卷诗书》，选取7个朝代、44位有代表性的文人及其作品，
              涵盖10几种文学体裁，开发出310期节目。3位著名语言艺术家联袂朗读，带领听众踏上一场从诗词歌赋到人情练达的传统文化之旅。</p>
            <!-- <img src="../../../static/img/whac_readdetail.png" alt=""> -->
          </div>
          <div>
            <img src="../../../static/img/events/24.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p>4月</p>
            <p>-2019-</p>
          </div>
          <div class="waudcs_content" >
            <p class="changeOfLanguage">「为你读诗」与QQ音乐推出「且听歌吟」栏目 </p>
            <p class="changeOfLanguage">2019年4月15日，2019年4月15日，「为你读诗」和QQ音乐联袂推出「且听歌吟」，这是一档音乐人自述的音乐故事特别节目。</p>
            <!-- <img src="../../../static/img/whac_readdetail.png" alt=""> -->
          </div>
          <div>
            <img src="../../../static/img/events/23.jpeg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">9月</p>
            <p>-2018-</p>
          </div>
          <div class="waudcs_content" >
            <p class="changeOfLanguage">「为你读诗」参与微信官方“微信太空诗人”活动</p>
            <p class="changeOfLanguage">2018年9月14日，「为你读诗」携手中国航天、微信官方发起“微信太空诗人”活动，线上征集了50000名全球大众朗读的诗歌内容。大众的诗意之声于10月末搭载⻑征四号系列运载火箭进入神秘宇宙。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/21.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">4月</p>
            <p>-2018-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「文艺学堂」推出《让经典说话》系列产品 </p>
            <p class="changeOfLanguage">2018年4月10日，「为你读诗」文艺学堂深入中国古典文学领域，策划推出中国古典文学鉴赏系列产品《让经典说话》，该系列共8个专栏，242期节目，从《诗经》《楚辞》两大源头着手，延续汉乐府、唐宋诗词，再到诗词论著、经典文言文，涵盖诗、词、歌、赋、文等文学体裁。</p>
          </div>
          <div>
            <img src="../../../static/img/events/20.jpeg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
         <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">4月</p>
            <p>-2018-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">黄轩携手「为你读诗」共同创立新品牌「瞬间MomentX」 </p>
            <p class="changeOfLanguage">2018年4月23日，「为你读诗」联合黄轩先生，共同创立生活方式品牌 “瞬间MomentX”，倡导“专注当下”的生活方式。希望通过日常内容分享、公众教育和产品服务，邀请人们在快节奏的当代生活中，修复自己的专注力、感受力和定力。</p>
          </div>
          <div>
            <img src="../../../static/img/events/momentX.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">12月</p>
            <p>-2017-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」受邀赴青瓦台为韩国总统夫人录制读诗 </p>
            <p class="changeOfLanguage">2017年12月，韩国总统文在寅访华前夕，「为你读诗」受韩国政府邀请，赴青瓦台为韩国总统夫人金正淑女士录制读诗作品，并在随后推出「为你读诗」韩国文化周。</p>
          </div>
          <div>
            <img src="../../../static/img/events/hanguo.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
         <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">6月</p>
            <p>-2017-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">全行业首个由明星参与的有声文学专辑上线</p>
            <p class="changeOfLanguage">2017年6月1日，「为你读诗」X 赵又廷，上线全行业首个由明星参与的有声文学专辑《在所有的声音中，我倾听你》，并倾力打造“诗的光合作用”这一品牌项目，包括数字专辑、实体书、签售会、音乐会等。</p>
          </div>
          <div>
            <img src="../../../static/img/events/zhaoyouting.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">3月</p>
            <p>-2017-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「文艺学堂」付费课程平台上线</p>
            <p class="changeOfLanguage">  2017年3月26日，「为你读诗」文艺学堂上线，并推出第一个人文知识付费产品《相伴四季：古诗词特辑》。「为你读诗」文艺学堂，希望向大众和青少年，提供兼具知识、审美和情感意义的优质人文艺术课程。</p>
          </div>
          <div>
            <img src="../../../static/img/events/16.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">3月</p>
            <p>-2017-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」举行2017世界诗歌日特别活动</p>
            <p class="changeOfLanguage">2017年3月21日，「为你读诗」2017世界诗歌日特别活动，将目光投向青年，获得全球百所高校参与和支持。</p>
          </div>
          <div>
            <img src="../../../static/img/events/15.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">2月</p>
            <p>-2017-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">赵又廷读诗成为「为你读诗」年度最受欢迎节目</p>
            <p class="changeOfLanguage">2017年2月12日，「为你读诗」发表演员赵又廷的读诗节目，全网阅读数超过5000万次，成为当年度最受欢迎的朗读节目。</p>
          </div>
          <div>
            <img src="../../../static/img/events/14.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">9月</p>
            <p>-2016-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」为贵州卫视定制中秋古诗词会</p>
            <p class="changeOfLanguage">2016年9月，受贵州省委宣传部邀请，「为你读诗」为贵州卫视量身制作中秋古诗词会。「为你读诗」的舞台艺术作品首次完整触电。</p>
          </div>
          <div>
            <img src="../../../static/img/events/13.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">6月</p>
            <p>-2016-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」短视频上线</p>
            <p class="changeOfLanguage">2016年6月，「为你读诗」系列视频短片陆续上线。</p>
          </div>
          <div>
            <img src="../../../static/img/events/12-1.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">4月</p>
            <p>-2016-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」官方APP上线</p>
            <p class="changeOfLanguage">2016年4月20日，「为你读诗」推出官方APP，为人们提供更多诗意生活的可能。</p>
          </div>
          <div>
            <img src="../../../static/img/events/11-1.png" alt="" style="width:256px;height:164px;margin-bottom:20px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">3月</p>
            <p>-2016-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」举行中国第二届世界诗歌日音乐会</p>
            <p class="changeOfLanguage">2016年3月20日，「为你读诗」举行中国第二届世界诗歌日音乐会。时任联合国教科文组织总干事伊琳娜·博科娃参与「为你读诗」。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/10.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">12月</p>
            <p>-2015-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」全球累计传播超过5亿人次</p>
            <p class="changeOfLanguage">2015年12月31日，「为你读诗」累计传播超过5亿人次，覆盖包括中国大陆、港澳台以及美国、加拿大、丹麦、德国、荷兰、意大利、日本、韩国、柬埔寨、南非等四十多个国家和地区。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/9.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">6月</p>
            <p>-2015-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage"> 爱尔兰总统希金斯先生朗读叶芝</p>
            <p class="changeOfLanguage">2015年6月12日，为纪念诗人叶芝诞辰150周年，「为你读诗」获爱尔兰总统希金斯先生特别授权，播出其读诗作品《为我女儿的祈祷》。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/8.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">4月</p>
            <p>-2015-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage"> 「为你读诗」发表首部有声诗歌作品集</p>
            <p class="changeOfLanguage">2015年4月20日，「为你读诗」首部有声诗歌作品集发表，这是全球第一部由各行业翘楚共同参与的有声文学作品集。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/7.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div> 
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">4月</p>
            <p>-2015-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage"> 「诗意空间」电商平台上线</p>
            <p class="changeOfLanguage">2015年4月8日，「为你读诗」旗下生活美学电商平台「诗意空间」正式上线，倡导以诗造物，用心生活。</p>
          </div>
          <div>
            <img src="../../../static/img/events/6.png" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>   
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">3月</p>
            <p>-2015-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage"> 「为你读诗」举行中国首届世界诗歌日音乐会</p>
            <p class="changeOfLanguage">2015年3月21日，「为你读诗」举行中国首届世界诗歌日音乐会，将诗歌以音乐、舞蹈、戏剧等多种方式展示。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/5.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>  
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">4月</p>
            <p>-2014-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">丹麦女王为孩子们读《丑小鸭》</p>
            <p class="changeOfLanguage">2014年4月20日，「为你读诗」独家首播丹麦女王玛格丽特二世为孩子所读的童话《丑小鸭》(节选)，并开展了“丹麦文化周”项目。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/4.jpeg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">3月</p>
            <p>-2014-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">「为你读诗」参加湖南卫视《天天向上》</p>
            <p class="changeOfLanguage">2014年3月7日，「为你读诗」携手湖南卫视《天天向上》推出“世界诗歌日特别节目”。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/3.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>  
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">7月</p>
            <p>-2013-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">基努·里维斯和夏雨参加「为你读诗」首场音乐诗会</p>
            <p class="changeOfLanguage">2013年7月4日，「为你读诗」举办首场线下音乐诗会，基努·里维斯、夏雨等嘉宾在现场倾情朗读，以中英双语诗歌朗读的方式互达情谊。 </p>
          </div>
          <div>
            <img src="../../../static/img/events/2.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>  
        <div class="waudc_slider tcf-flex tcf-justify-justify">
          <div class="waudcs_num">
            <p class="changeOfLanguage">6月</p>
            <p>-2013-</p>
          </div>
          <div class="waudcs_content">
            <p class="changeOfLanguage">Be My Guest携手20位行业翘楚共同推出「为你读诗」</p>
            <p class="changeOfLanguage">2013年6月1日，「为你读诗」由中国诗意生活倡导者Be My Guest（中文名：尚客私享家）携手20位各行业翘楚共同推出，并首播由李彦宏、沈南鹏、李静等嘉宾联袂朗读的作品《给我未来的孩子》。 </p>
          </div>
          <div class="dsj_img">
            <img src="../../../static/img/events/1.jpg" alt="" style="width:240px;height:150px;margin-bottom:40px;margin-right:20px;">
          </div>
        </div>  
      </div>
    </div>

    <div class="wau_cstd">
      <div class="title">
        <h2>创始团队</h2>
        <div></div>
      </div>
      <div class="wau_cstd_cont">
        <img class="waucc_content_lf" src="../../../static/img/pan_03.png" alt="">
        <div class="waucc_content_rg">
          <ul class="waucc_content_text tcf-flex tcf-justify-end tcf-align-items-end">
            <li>
              <p>潘杰客</p> 
              <p>「为你读诗」创始人，中国北京，2013年至今；</p> 
              <p>Be My Guest 创始人，中国北京，2006年至今；</p> 
              <p>曾担任：</p>
              <p>上海东方卫视独立制片人、主持人，中国上海；</p> 
              <p>凤凰卫视资讯台主持人，中国香港；</p> 
              <p>德国奥迪汽车集团大中华区营销总监，德国巴伐利亚区；</p> 
              <p>中美文化交流基金会主席，美国纽约；</p> 
              <p>国家建设部党委宣传部副部长，中国北京；</p> 
              <p>中国建筑工程总公司工程师、项目经理，中国北京。</p>
            </li> 
            <li style="margin-bottom: 140px;">
              <p>教育背景</p> 
              <p>曾在中国、美国及欧洲的大学分别接受本科、硕士及博士教育。</p>
              <!-- <p>爱尔兰都柏林大学艺术学硕士，爱尔兰都柏林；</p>
              <p>美国哈佛大学管理学硕士，美国波士顿；</p>
              <p>中国重庆大学工程学学士，中国重庆。</p> -->
            </li>
          </ul>
        </div>
      </div>
      <div class="wau_cstd_zhang">
        <div class="waucc_content_zhang">
          <ul class="waucc_content_text1 ">
            <li>
              <p>张炫</p> 
              <p> 「为你读诗」联合创始人，2013年至今;</p> 
              <p> 自2017年开始任「为你读诗」总裁，2019年1月起担任「为你读诗」CEO；</p>
              <p>与此同时，自2009年起一直担任Be My Guest联合创始人、执行人；</p>
              <p>曾分别于中国新闻周刊、时尚传媒集团工作。</p>
            </li> 
            <li  class="zhangxuan">
              <p>教育背景</p> 
              <p>毕业于北京师范大学汉语言文学专业。</p>
            </li>
          </ul>
        </div>
        <img src="../../../static/img/zhang_07.png" alt="" class="waucc_content_zhang_rg">
      </div>
    </div>

    <!-- <div class="wau_lhfqr">
        <div class="title">
          <h2>联合发起人</h2>
          <div></div>
          <h3 style="line-height:26px;">移动光标至头像查看详情 <br> 以下排名不分先后，按姓名首字母顺序排序 </h3>
      </div>
        <ul class="tcf-flex tcf-justify-justify">
          <li>
            <img src="../../../static/img/about_founder_09.png" alt="">
            <p>陈鲁豫</p>
            <div class="founder_msg">
              <p>凤凰卫视主持人</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_02.png" alt="">
            <p>邓中翰</p>
            <div class="founder_msg">
              <p> “中国芯之父” <br>中国科协副主席 <br> 中国工程院院士</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_16.png" alt="">
            <p>黄怒波</p>
            <div class="founder_msg">
              <p>北京中坤投资集团 <br> 董事长 <br> 中国诗歌学会会长</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_15.png" alt="">
            <p>姜昆</p>
            <div class="founder_msg">
              <p>相声表演艺术家<br> 中国曲艺家协会主席</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_14.png" alt="">
            <p>郎朗</p>
            <div class="founder_msg">
              <p>钢琴家 <br> 施坦威艺术家<br> 联合国和平大使</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_04.png" alt="">
            <p>李彦宏</p>
            <div class="founder_msg">
              <p>百度创始人<br>董事长兼CEO</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_03.png" alt="">
            <div style="width:55px;height:25px;border:1px solid black;line-height: 26px;margin: 14px auto;"><p>刘江</p></div>
            <div class="founder_msg">
              <p>时尚集团董事长 <br> 《时尚》杂志社 <br> 创办人</p>
              <i class="visible"></i>
            </div>
          </li>  
        </ul> 
         
        <ul class="tcf-flex tcf-justify-justify">
          <li>
            <img src="../../../static/img/about_founder_05.png" alt="">
            <p>吕思清</p>
            <div class="founder_msg">
              <p>小提琴家<br>意大利帕格尼尼<br>小提琴大赛金奖获得者</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_17.png" alt="">
            <p>彭雪峰</p>
            <div class="founder_msg">
              <p>全国政协常委<br> 大成全球董事局主席<br>北京大成律师事务所<br>创始人 </p>
              <i class="visible"></i>
            </div>
          </li>  
          <li>
            <img src="../../../static/img/about_founder_19.png" alt="">
            <p>濮存昕</p>
            <div class="founder_msg">
              <p>国家一级演员 <br> 表演艺术家 <br>中国戏剧家协会主席</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_10.png" alt="">
            <p>邵忠</p>
            <div class="founder_msg">
              <p>现代传播集团创始人 <br>现代资讯传播有限公司 <br>董事长及总编辑</p>
              <i class="visible"></i>
            </div>
          </li> 
          <li>
            <img src="../../../static/img/about_founder_08.png" alt="">
            <p>沈南鹏</p>
            <div class="founder_msg">
              <p>红杉资本中国基金<br>创始及执行合伙人</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_18.png" alt="">
            <p>熊晓鸽</p>
            <div class="founder_msg">
              <p>IDG资本创始合伙人</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_07.png" alt="">
            <p>严彬</p>
            <div class="founder_msg">
              <p>华彬集团董事长</p>
              <i class="visible"></i>
            </div>
          </li>     
        </ul>
 
        <ul class="tcf-flex tcf-justify-justify">
          <li>
            <img src="../../../static/img/about_founder_06.png" alt="">
            <p>杨元庆</p>
            <div class="founder_msg">
              <p>联想集团董事长兼CEO</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_01.png" alt="">
            <p>于丹</p>
            <div class="founder_msg">
              <p>文化学者 <br> 北京师范大学教授 <br> 博士生导师</p>
              <i class="visible"></i>
            </div>
          </li> 
          <li>
            <img src="../../../static/img/about_founder_13.png" alt="">
            <p>张国立</p>
            <div class="founder_msg">
              <p>国家一级演员 <br> 导演 制作人 主持人</p>
              <i class="visible"></i>
            </div>
          </li>
           <li>
            <img src="../../../static/img/about_founder_11.png" alt="">
            <p>张亚勤</p>
            <div class="founder_msg">
              <p>百度总裁<br>时任微软全球副总裁<br>兼亚太研发集团主席</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_12.png" alt="">
            <p>张延平</p>
            <div class="founder_msg">
              <p>时任北京青年报社社长<br>北青传媒集团董事长</p>
              <i class="visible"></i>
            </div>
          </li>
          <li>
            <img src="../../../static/img/about_founder_20.png" alt="">
            <p>潘杰客</p>
            <div class="founder_msg">
              <p>Be My Guest 创始人 <br> 「为你读诗」创始人</p>
              <i class="visible"></i>
            </div>
          </li>
          <li></li>
        </ul>
     
    </div> -->

    <div class="mtjzBox">
      <div class="wau_mthb">
      <div class="title" style="margin-bottom:90px;">
        <h2>媒体矩阵</h2>
        <div></div>
        <!-- <h3>MEDIA MATRIX</h3> -->
      </div>
      <div class="imgbox">
        <img src="../../../static/img/images/aboutus11_03.png" alt="">
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "about",
	data(){
		return{
			
		}
  },
  created(){
		this.$parent.activeIndex = 'about'
  },
  mounted() {
    //监听页面滚动事件
    window.addEventListener('scroll', this.scrollFn)
    //注意：如果由于自己的vue中的样式导致监听不到，可以尝试监听body或者'#app-root'的滚动事件
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollFn)
  },
  methods:{
    toScrollFn(scrollNum){
      // document.documentElement.scrollTop=scrollNum;
      document.body.scrollTop=scrollNum;
      document.documentElement.scrollTop=scrollNum;
      document.body.scrollTop = scrollNum;
    },
    scrollFn(){
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var titleTop = document.querySelector('#wauc_title').offsetTop;
      var titleParTop = document.querySelector('#wau_contbox_padding').offsetTop;
      // console.log(scrollTop,titleTop,titleParTop,111111111)
      if ( scrollTop >= titleParTop){
        $("#wauc_title").addClass("wauc_title_fixed")
      }else{
        $("#wauc_title").removeClass("wauc_title_fixed")
      }
      if( scrollTop < 1000 ){
        $(".wauc_btnlist div:nth-child(1)").addClass("wauc_btnlist_active").siblings().removeClass("wauc_btnlist_active")
      }else if( scrollTop >=1380 && scrollTop < 2470 ){
        $(".wauc_btnlist div:nth-child(2)").addClass("wauc_btnlist_active").siblings().removeClass("wauc_btnlist_active")
      }else if( scrollTop >=2470 && scrollTop < 3470){
        $(".wauc_btnlist div:nth-child(3)").addClass("wauc_btnlist_active").siblings().removeClass("wauc_btnlist_active")
      }else if( scrollTop >=2454 && scrollTop < 4045){
        $(".wauc_btnlist div:nth-child(4)").addClass("wauc_btnlist_active").siblings().removeClass("wauc_btnlist_active")
      }else if( scrollTop >=4045){
        $(".wauc_btnlist div:nth-child(5)").addClass("wauc_btnlist_active").siblings().removeClass("wauc_btnlist_active")
      }
    }
  },
  
}
</script>
<style scoped>
.otherLang{
  line-height: 34px !important;
  margin-top: -20px;
}
.wnds_about_us{
  display: inline-table;
  width: 100%;
  background: #fff;
}
.wau_banner, .wau_banner img {
  width: 100%;  
  font-size: 0;
}
.wau_contbox {
    width: 1200px;
    margin: 0 auto;
    font-family: myfont;
}
.wauc_title {
    width: 1140px;
    margin: 0 auto;
}
.wauc_title_fixed {
    width: 100%;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}
.wauc_btnlist, .wauc_title {
    font-size: 16px;
    line-height: 16px;
    color: #555;
}
.wauc_title li {
    height: 80px;
    line-height: 80px;
}
.wauc_btnlist {
    width: 400px;
}
.wauc_btnlist_active {
    color: #8ca764;
}
.wauc_btnlist div {
    cursor: pointer;
    position: relative;
}
.wauc_btnlist img {
    display: none;
    margin-left: -9px;
    position: absolute;
    bottom: 16px;
    left: 50%;
}
.wauc_btnlist .wauc_btnlist_active img {
    display: block;
}
hr {
    height: 1px;
    background-color: #cacaca;

}
.wau_zongzhi {
    width: 1140px;
    margin: 0 auto;
    padding: 100px 28px 0;
    position: relative;
}
.wau_zongzhi .wau_zongzhi_icon {
    position: absolute;
    top: 58px;
    right: -118px;
}
.wau_zongzhi .wau_zongzhi_iconlf {
    position: absolute;
    bottom: 0;
    left: -122px;
}
.wauz_text {
    width: 560px;
    font-size: 14px;
    line-height: 20px;
    text-align: justify;
    color: #838383;
}
.wauz_text img {
    margin-top: 15px;
    margin-bottom: 25px;
}
.wauz_text p {
    margin-bottom: 25px;
}
.wauz_text p:last-child {
    margin-bottom: 0;
}
.wau_zongzhi_bg {
    height: 190px;
    margin-top: 74px;
    padding: 0 28px;
}
.wau_zongzhi_bg>div:first-child {
    width: 39px;
    height: 100%;
    background-color: #f8f8f8;
}
.wau_zongzhi_bg>div:nth-child(2) {
    width: 1090px;
    height: 100%;
    background-color: #f8f8f8;
}
.wauzb_box {
    width: 100%;
    height: 100%;
    position: relative;
}
.wauzb_lf {
    position: absolute;
    top: 22px;
    left: 40px;
}
.wauzb_ct {
    margin-top: 34px;
}
.wauzb_rg {
    width: 550px;
    padding: 34px 0;
    margin-left: 88px;
}
.wauzb_rg p:nth-child(2) {
    margin-top: 16px;
    margin-bottom: 20px;
    font-size: 12px;
    line-height: 20px;
    color: #838383;
}
.wauzb_rg p:first-child, .wauzb_rg p:nth-child(3) {
    font-size: 14px;
    line-height: 14px;
    color: #838383;
}
.wau_dsj {
    width: 1140px;
    padding-top: 138px;
    margin: 0 auto;
}
.waud_content{
  height: 971px;
  overflow-y: scroll;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar
{
    width: 8px;
    /* height: 16px; */
    background-color: #F5F5F5;
}
 
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); */
    border-radius: 10px;
    background-color: #F5F5F5;
}
 
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.1); */
    background-color: #b9d990;
}
.wau_dsj>img {
    display: block;
    margin: 0 auto;
    margin-bottom: 40px;
}
.waudc_slider {
    padding-top: 50px;
    padding-right:10px;
    /* padding-bottom: 15px;、 */
    border-bottom: 1px solid #bfbfbf;
}
/* .dsj_img img{
  width: 300px;
  height: 170px;
}
.dsj_img{
  width: 300px;
  height: 170px;
} */
.waudcs_num {
    overflow: hidden;
    width: 84px;
    height: 84px;
    text-align: center;
    border: 4px solid #8ca764;
}
.waudcs_num p:first-child {
    margin-top: 16px;
    margin-bottom: 10px;
    font-size: 24px;
    line-height: 24px;
    font-weight: 600;
    color: #676767;
}
.waudcs_num p:nth-child(2) {
    margin: 13px 0;
    font-size: 12px;
    line-height: 12px;
    color: #969696;
}
.waudcs_content {
    width: 650px;
    margin-top: 15px;
}
.waudcs_content p:first-child {
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 22px;
    line-height: 22px;
    color: #5a5a5a;
    text-indent: -.5em;
}
.waudcs_content p:nth-child(2) {
    font-size: 12px;
    line-height: 24px;
    color: #969696;
}
.zhangxuan{
  margin-top: 30px;
  counter-reset: #303030;
}
.waudcs_content img {
    margin-top: 40px;
}
.wau_cstd {
    width: 1140px;
    margin: 0 auto;
    margin-top: 140px;
}
.wau_cstd>img {
    display: block;
    margin: 0 auto;
}
.wau_cstd_cont {
    margin-top: 88px;
    position: relative;
}
.waucc_content_lf {
    position: absolute;
    top: 0px;
    left: 0;
    z-index: 666;
    /* width: 360px; */
    height: 339px;
}
.waucc_content_rg {
    overflow: hidden;
    width: 1086px;
    height: 339px;
    margin-left: 54px;
    background-color: #f8f8f8;
    position: relative;
}
.waucc_content_rg img{
  width: 100%;
  height: 100%;
}
.waucc_content_text,.waucc_content_text1 {
    margin-top: 62px;
    padding-right: 45px;
    color: #303030;
    font-weight: 500;
}
.waucc_content_text1 {
  margin-top: 62px;
    padding-right: 30px;
    color: #303030;
    font-weight: 500;
}
.waucc_content_text p:first-child,.waucc_content_text1 p:first-child{
  font-weight: 600;
  letter-spacing: 3px;
}
.waucc_content_text1{
  margin-left: 80px;
}
.waucc_content_text li:first-child,.waucc_content_text1 li:first-child {
    font-size: 14px;
    line-height: 23px;
    margin-top: -20px;
}
.waucc_content_text li:first-child p:nth-child(1), .waucc_content_text1 li:first-child p:nth-child(1){
    margin-bottom: 20px;
    color: #101010;
    font-size: 18px;
}
.waucc_content_text li:first-child p:nth-child(2),.waucc_content_text1 li:first-child p:nth-child(2) {
    text-indent: -.5em;
}
.waucc_content_text li:nth-child(2),.waucc_content_text1 li:nth-child(2) {
    font-size: 12px;
    line-height: 21px;
}
/* .waucc_content_text li:nth-child(2) p:first-child {
    margin-bottom: 15px;
} */
.waucc_content_page {
    margin-top: 28px;
    margin-left: 362px;
    font-size: 16px;
    color: #8c8c8c;
}
.waucc_content_page i {
    cursor: pointer;
    font-size: 20px;
    vertical-align: -1px;
}
.waucc_content_page .el-icon-arrow-left {
    margin-right: 14px;
}
.waucc_content_page .el-icon-arrow-right {
    margin-left: 14px;
}
.wau_lhfqr {
    width: 1140px;
    margin: 0 auto;
    margin-top: 140px;
}
.lhcsr{
  text-align: center;
}
.lhcsr h2{
  margin-bottom: 27px;
  margin-left: 10px;
  color: #5f5f5f;
  font-size: 26px;
  letter-spacing: 6px;
  font-weight: 500;
}
.wau_lhfqr>img {
    display: block;
    margin: 0 auto;
}
.wau_lhfqr ul:nth-child(2) {
    margin-top: 84px;
}
.wau_lhfqr ul li {
    display: table;
    width: 126px;
    text-align: center;
    font-size: 18px;
    line-height: 18px;
    color: #303030;
    position: relative;
}
.wau_lhfqr ul li>p {
    margin-top: 18px;
    margin-bottom: 40px;
}
.wau_lhfqr ul li:hover .founder_msg {
  opacity: 1;
}
.founder_msg p{
  font-size: 10px;
}
.wau_lhfqr .founder_msg {
  display: table; /*重点*/
  opacity: 0;
  cursor: pointer;
  width: 120px;
  height: 120px;
  padding: 4px;
  margin: 0;
  color: #e0e0e0;
  font-size: 12px;
  /* line-height: 125px; */
  text-align: center;
  background-color: rgba(0, 0, 0, .7);
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}
.wau_lhfqr .founder_msg p {
  display: table-cell;
  vertical-align:middle;
  text-align:center;
  /* display: inline; */
  /* zoom: 1; */
}
.wau_lhfqr>img {
  display: block;
  margin: 0 auto;
}
.wau_mthb {
    width: 1200px;
    margin: 0 auto;
    margin-top: 90px;
    font-size: 0;
}
.wau_mthb>img {
    display: block;
    margin: 0 auto;
    margin-bottom: 86px;
    margin-top: 70PX;
}
.wau_mthb>img:last-child {
    margin-bottom: 140px;
}
.waum_mapbox, .waum_msg {
    width: 61.7%;
    height: 413px;
    overflow: hidden;
    background-color: #f1f1f1;
}
.waum_mapbox img {
    width: 100%;
}
.waum_margin {
    width: 14px;
    margin: 0;
    padding: 0;
}
.waum_msg {
    overflow: hidden;
    width: 37.5%;
    font-size: 20px;
    color: #242424;
}
.waum_msgbox>p, .waum_msgbox div {
    width: 84.7%;
    padding: 43px 0;
    margin-left: 55px;
    border-bottom: 1px dashed #aaa;
}
.waum_msg div p {
    display: inline-block;
}
.waum_msg img {
    margin-right: 40px;
}
.waum_msgbox>p:nth-child(3) {
    border: 0;
}

.waucc_content_zhang{
  width: 1144px;
  height: 292px;
  background: #f0f0f1;
  margin-top: 30px;
  position: absolute;
}
.waucc_content_zhang_rg {
    position: relative;
    top: 30px;
    right: -850px;
    z-index: 666;
   
}
.title{
  text-align: center;
  color: #5f5f5f;
  margin-bottom: 30px;
}
.title h2{
  letter-spacing: 6px;
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 27px;
}
.title div{
  width: 75px;
  height: 5px;
  background: #8ca764;
  margin:  0 auto;
}
.title h3{
  font-size: 16px;
  color: #a4a4a4;
  letter-spacing: 2px;
  font-weight: 500;
  margin-top: 27px;
  margin-bottom: 20px;
}
.mtjzBox{
  width: 100%;
 background: #fff !important;
}
.imgbox{
  position: relative;
  margin-left: 20px;
  padding-bottom: 100px;
}
.imgbox .weixin{
  width: 145px;
  height: 55px;
  position: relative;
  bottom: 60px;;
  right: -990px;;
}
</style>



// WEBPACK FOOTER //
// src/components/page/About.vue